import apiInterceptor from "./Interceptors/ApiInterceptor";


export const getApplicationsServ = async () => {
    try {
        const response = await apiInterceptor.get(`/get-applications-analytics`);
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getCombineAppsServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-combine-applications`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}


export const getNetworksServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-networks-analytics`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getPackagesServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-packages-analytics`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}
export const getPortsServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-ports-analytics`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getProcessesServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-processes-analytics`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getDashboardAnalyticsServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-dashboard-analytics`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getFilesServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-files`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}


export const deleteFileServ = async (payload) => {
    try {
        const response = await apiInterceptor.delete(`/delete-file`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}


export const getFimServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-fim-data`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getDeviceUsersServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/get-device-users`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getDeviceUsersV2Serv = async (deviceId) => {
    try {
        if (!deviceId) throw new Error("deviceId is required");
        // Use base URL from environment to avoid hard-coding host.
        const base = process.env.REACT_APP_API_URL || "";
        // Ensure no duplicate slashes when joining
        const normalizedBase = base.replace(/\/$/, "");
        const url = `${normalizedBase}/users/deviceUsers/${deviceId}`;

        const response = await apiInterceptor.get(url);
        return response; // return full axios response so caller can inspect response.data
    } catch (error) {
        throw error;
    }
}

export const getDeviceStartedSessionsServ = async (payload) => {
    try {
        const { deviceId, date, filterType, searchTerm } = payload || {};
        if (!deviceId) {
            throw new Error("deviceId is required");
        }

        const params = {};
        if (date) params.date = date;
        if (filterType) params.filterType = filterType;
        if (searchTerm) params.searchTerm = searchTerm;

        const response = await apiInterceptor.get(`/users/device-session/started/${deviceId}`, {
            params,
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const getUserSessionsByDeviceServ = async (payload) => {
    try {
        const response = await apiInterceptor.post(`/users/sessions/device`, payload);
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getDeviceSessionsServ = async (payload) => {
    try {
        const { deviceId, page = 1, pageSize = 25, filterType, searchTerm } = payload || {};
        if (!deviceId) {
            throw new Error("deviceId is required");
        }

        const params = { page, pageSize };
        if (filterType) params.filterType = filterType;
        if (searchTerm) params.searchTerm = searchTerm;

        const response = await apiInterceptor.get(`/users/device-session/${deviceId}`, {
            params,
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const toggleSecurebootStatusServ = async ({ deviceId, username, enable }) => {
    try {
        if (!deviceId || !username || typeof enable !== "boolean") {
            throw new Error("deviceId, username and enable (boolean) are required");
        }

        const base = process.env.REACT_APP_API_URL || "";
        const normalizedBase = base.replace(/\/$/, "");
        const url = `${normalizedBase}/users/secureboot/toggle`;
        const response = await apiInterceptor.post(url, {
            deviceId,
            username,
            enable,
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const fetchAlertsService = async (payload) => {
    try {
        const response = await apiInterceptor.get("/get-device-alerts", { params: payload });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const getAnomaliesService = async (payload) => {
    try {
        const response = await apiInterceptor.get("/get-device-anomalies", { params: payload });
        return response?.data;
    } catch (error) {
        throw error;
    }
};



export const getMalwareHashesServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/search-app-hash`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getBlockChainServ = async () => {
    try {
        const response = await apiInterceptor.get(`/blockchain/get-org-blockchain`);
        return response?.data;
    } catch (error) {
        throw error;
    }
}

export const getBlockChainBlockServ = async (payload) => {
    try {
        const response = await apiInterceptor.get(`/blockchain/get-device-block`, {
            params: payload
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
}



